import { useState } from 'react';
import { getContactEmailDisplay } from '@car-pool/shared/contactIdentity';
import { apiFetch } from '../config/api';

export default function SendOnboardingEmailButton({ token, parentId, schoolId, hasPassword = false, contact = null }) {
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSend = async () => {
    if (hasPassword && !window.confirm('This user is already on board. Send the onboarding email anyway?')) {
      return;
    }

    setSending(true);
    setSent(false);
    setError('');

    try {
      await apiFetch(`/contacts/${parentId}/onboarding-email`, {
        method: 'POST',
        body: JSON.stringify({ school_id: schoolId, force: hasPassword }),
      }, token);
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSending(false);
    }
  };

  // Nothing can be emailed to a contact with no real address — a driver invited
  // through the public link holds an undeliverable @invite.local placeholder.
  // The send is refused by the backend anyway; offering the button just invites
  // a confusing failure, so prompt for an address and leave WhatsApp as the route.
  const emailDisplay = contact ? getContactEmailDisplay(contact) : null;
  if (emailDisplay?.needsEmail) {
    return (
      <span className="sap-needs-email" style={{ fontSize: 12 }}>
        No email on file — add one to send onboarding by email
      </span>
    );
  }

  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
      <button
        className="sa-btn sa-btn-secondary"
        style={{ padding: '4px 10px', fontSize: 12 }}
        onClick={handleSend}
        disabled={sending || sent}
      >
        {sending ? 'Sending...' : sent ? 'Onboarding Sent' : 'Send Onboarding Email'}
      </button>
      {error ? <span style={{ color: '#991b1b', fontSize: 12 }}>{error}</span> : null}
    </div>
  );
}
